/**
 * Skeleton loading placeholder — matches dads-components Skeleton API (Phase 5.3b).
 *
 * Renders an animated placeholder while content loads. Replace with
 * `import { Skeleton } from '@dc/dads-components'` when the vendored
 * package includes it.
 */

import { clsx } from 'clsx'

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Additional CSS classes. */
  className?: string
}

/**
 * Animated placeholder for loading states.
 * Same API as dads-components Skeleton — className passthrough for sizing.
 */
export function Skeleton({ className, ...props }: SkeletonProps) {
  return (
    <div className={clsx('animate-pulse rounded-md bg-surface-secondary', className)} {...props} />
  )
}
